/**
 * @flow
 * @relayHash b3fc576da92c4ae70c2fdfd1c4cb0233
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type acceptImportsMutationVariables = {|
  importPks?: ?$ReadOnlyArray<?number>
|};
export type acceptImportsMutationResponse = {|
  +acceptImports: ?{|
    +ok: ?boolean,
    +error: ?{|
      +statusCode: ?number
    |},
    +redirectUrl: ?string,
  |}
|};
export type acceptImportsMutation = {|
  variables: acceptImportsMutationVariables,
  response: acceptImportsMutationResponse,
|};
*/


/*
mutation acceptImportsMutation(
  $importPks: [Int]
) {
  acceptImports(importPks: $importPks) {
    ok
    error {
      statusCode
    }
    redirectUrl
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "importPks",
    "type": "[Int]",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "acceptImports",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "importPks",
        "variableName": "importPks",
        "type": "[Int]"
      }
    ],
    "concreteType": "AcceptImportsMutation",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "ok",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "error",
        "storageKey": null,
        "args": null,
        "concreteType": "ErrorType",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "statusCode",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "redirectUrl",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "acceptImportsMutation",
  "id": "1afd2fee0bd883ae489aa1d6c92656da",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "acceptImportsMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "acceptImportsMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
node.text = "mutation acceptImportsMutation(\n  $importPks: [Int]\n) {\n  acceptImports(importPks: $importPks) {\n    ok\n    error {\n      statusCode\n    }\n    redirectUrl\n  }\n}\n";
(node/*: any*/).hash = '5c670b56cb0a85765644abef67b8650c';
module.exports = node;
